import { Box, Stack } from "@mui/material";
import React from "react";

import { ParlorDetailProps } from "../../../types";

import { DTypeMainHead } from "../MainHead";
import { ColorSystemProps } from "../../../constants";
import ATypeRegionPriceSummaryItem from "./ATypeRegionPriceSummaryItem";

export function DTypeRegionHead({
  regionParlors,
  sidoName,
  sigunguName,
  expectedParlorPrice,
  mainColor,
}: {
  regionParlors: Array<ParlorDetailProps>;
  sidoName: string;
  sigunguName?: string;
  expectedParlorPrice: any;
  mainColor: ColorSystemProps;
}) {
  const name = `${sidoName}${sigunguName ? " " + sigunguName : ""}`;
  return (
    <>
      <DTypeMainHead
        title={`${sidoName}${sigunguName ? ` ${sigunguName} ` : " "}장례식장 추천`}
        sidoName={sidoName}
        sigunguName={sigunguName}
        defaultParlor={regionParlors[0]}
        mainColor={mainColor}
        isRegion
      />
      <Stack padding="20px">
        <Box width="100%" height="1px" style={{ background: "black" }} />
      </Stack>
      <Stack gap="6px" padding="20px">
        <Box className="subtitle_18_b">{name} 장례 요약</Box>

        <ATypeRegionPriceSummaryItem
          text="조문객 50명 기준 평균 빈소 비용"
          price={expectedParlorPrice.무빈소장}
        />
        <ATypeRegionPriceSummaryItem
          text="조문객 100명 기준 평균 빈소 비용"
          price={expectedParlorPrice.가족장}
        />
        <ATypeRegionPriceSummaryItem
          text="조문객 200명 기준 평균 빈소 비용"
          price={expectedParlorPrice.일반장}
        />
      </Stack>
      <Stack padding="20px">
        <Box width="100%" height="1px" style={{ background: "black" }} />
      </Stack>
    </>
  );
}
